import React from "react";
import { useCons } from "../context/ConsContext";
import "./index.css";

const Send = () => {
  const { themeOptions } = useCons();

  return (
    <div className="container-lg send">
      <div className="containerPop activePop">
        <div className="flex flexRow">
          <div className="textCol">
            <h1 className="relative">
              <span>Tu solicitud fué recibida</span>
            </h1>
            <h3>
              En breve un asesor de {""}
              {themeOptions.dealer}, Consecionario Oficial{" "}
              {themeOptions.carBrand}, se pondrá en contacto para ayudarte con
              todas tus dudas.
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Send;
